module.exports = __webpack_public_path__ + "img/sii--icon.37942d51.svg";